import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import PropTypes from 'prop-types';
import SearchLocation from './SearchLocation';

/**
 * SearchLocationDialog component.
 * @param {Object} props - The properties passed to the component.
 * @param {Object} props.map - The OpenLayers Map instance.
 */
export default function SearchLocationDialog({ map }) {
  const [open, setOpen] = useState(true);

  /**
   * Closes the dialog.
   */
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogContent sx={{ width: 320 }}>
        <SearchLocation map={map} onZoom={handleClose} />
      </DialogContent>
    </Dialog>
  );
}

SearchLocationDialog.propTypes = {
  map: PropTypes.object.isRequired,
};
